var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoin4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 129,
    viewBox: "0 0 71 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.3287 15.9971C98.2806 24.6071 99.4231 53.4276 84.8762 80.3729C70.3348 107.318 45.6144 122.182 29.6626 113.572C13.7108 104.962 12.5682 76.1417 27.1096 49.1964C41.6511 22.251 66.3715 7.38705 82.3233 15.9971H82.3287Z",
    fill: "url(#paint0_linear_502_8487)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1105 16.418C99.0623 25.028 100.205 53.8485 85.658 80.7938C71.1166 107.739 46.3961 122.603 30.4443 113.993C14.4925 105.383 13.35 76.5626 27.8914 49.6173C42.4328 22.6719 67.1532 7.80795 83.105 16.418H83.1105Z",
    fill: "url(#paint1_linear_502_8487)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4994 16.6257C99.6644 25.3506 100.982 54.2694 86.4405 81.2148C71.8991 108.16 47.0038 122.931 30.8333 114.206C14.6682 105.481 13.3508 76.5626 27.8922 49.6173C42.4336 22.6719 67.3289 7.90089 83.4994 16.6257Z",
    fill: "url(#paint2_linear_502_8487)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2802 17.0467C100.445 25.7715 101.763 54.6903 87.2213 81.6357C72.6799 108.581 47.7845 123.352 31.614 114.622C15.449 105.897 14.1315 76.9781 28.6729 50.0327C43.2144 23.0874 68.1097 8.31637 84.2802 17.0467Z",
    fill: "url(#paint3_linear_502_8487)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0624 17.4677C101.227 26.1925 102.545 55.1113 88.0035 82.0567C73.4621 109.002 48.5667 123.773 32.3962 115.048C16.2312 106.323 14.9138 77.4045 29.4552 50.4592C43.9966 23.5138 68.8919 8.74281 85.0624 17.4677Z",
    fill: "url(#paint4_linear_502_8487)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8388 17.8942C102.004 26.619 103.321 55.5379 88.7798 82.4832C74.2384 109.429 49.3431 124.2 33.1726 115.475C17.0076 106.75 15.6901 77.831 30.2315 50.8857C44.7729 23.9403 69.6683 9.16932 85.8388 17.8942Z",
    fill: "url(#paint5_linear_502_8487)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6205 18.3151C102.786 27.0399 104.103 55.9587 89.5616 82.9041C75.0202 109.849 50.1248 124.62 33.9544 115.896C17.7893 107.171 16.4719 78.2519 31.0133 51.3066C45.5547 24.3612 70.45 9.59022 86.6205 18.3151Z",
    fill: "url(#paint6_linear_502_8487)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4018 18.7359C103.567 27.4607 104.884 56.3796 90.3429 83.3249C75.8014 110.27 50.9061 125.041 34.7356 116.311C18.5706 107.586 17.2531 78.6673 31.7945 51.7219C46.3359 24.7766 71.2313 10.0056 87.4018 18.7359Z",
    fill: "url(#paint7_linear_502_8487)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1835 19.1568C104.349 27.8817 105.666 56.8005 91.1246 83.7459C76.5832 110.691 51.6878 125.462 35.5173 116.732C19.3523 108.007 18.0348 79.0882 32.5763 52.1429C47.1177 25.1975 72.013 10.4265 88.1835 19.1514V19.1568Z",
    fill: "url(#paint8_linear_502_8487)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9657 19.5778C105.131 28.3027 106.448 57.2215 91.9068 84.1669C77.3654 111.112 52.4701 125.883 36.2996 117.153C20.1345 108.428 18.8171 79.5093 33.3585 52.5639C47.8999 25.6185 72.7952 10.8475 88.9657 19.5724V19.5778Z",
    fill: "url(#paint9_linear_502_8487)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7421 19.9987C105.907 28.7236 107.225 57.6424 92.6832 84.5877C78.1418 111.533 53.2464 126.304 37.0759 117.574C20.9109 108.849 19.5934 79.9301 34.1349 52.9848C48.6763 26.0394 73.5716 11.2684 89.7421 19.9987Z",
    fill: "url(#paint10_linear_502_8487)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1016 79.9705C98.6466 53.0251 97.5064 24.2013 81.5549 15.5908C65.6034 6.9802 40.8811 21.8435 26.3361 48.7889C11.7911 75.7343 12.9313 104.558 28.8828 113.169C44.8343 121.779 69.5566 106.916 84.1016 79.9705Z",
    fill: "#0C0232"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9889 22.169C91.7869 29.6147 92.7709 54.5428 80.192 77.8473C67.6131 101.152 46.2329 114.004 32.4404 106.558C18.6424 99.1128 17.6584 74.1846 30.2318 50.8801C42.8107 27.5756 64.191 14.7234 77.9834 22.169H77.9889Z",
    fill: "#0C0232"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9889 22.169C91.7869 29.6147 92.7709 54.5428 80.192 77.8473C67.6131 101.152 46.2329 114.004 32.4404 106.558C18.6424 99.1128 17.6584 74.1846 30.2318 50.8801C42.8107 27.5756 64.191 14.7234 77.9834 22.169H77.9889Z",
    fill: "url(#paint11_linear_502_8487)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.8369 16.8937C96.3568 25.2687 97.4666 53.3128 83.3187 79.5311C69.1709 105.749 45.1175 120.209 29.5975 111.834C14.0776 103.459 12.9678 75.4147 27.1156 49.1964C41.2689 22.9781 65.3169 8.51871 80.8369 16.8937ZM80.1973 77.8474C92.7761 54.5428 91.7867 29.6147 77.9942 22.1691C64.1962 14.7234 42.816 27.5756 30.2426 50.8801C17.6637 74.1847 18.6532 99.1128 32.4457 106.558C46.2436 114.004 67.6239 101.152 80.2027 77.8474H80.1973Z",
    fill: "url(#paint12_linear_502_8487)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M59.448 52.7792L52.3766 45.7078C52.3305 45.6617 52.2726 45.6395 52.2157 45.6461C52.1588 45.6527 52.1075 45.6876 52.0732 45.7431L46.0149 55.5371C45.9392 55.6593 45.8944 55.8082 45.886 55.9661C45.8776 56.1239 45.9058 56.284 45.9673 56.4269L53.0077 72.5396C53.0698 72.6816 53.0986 72.841 53.0906 72.9983C53.0826 73.1556 53.038 73.3042 52.9624 73.4258L49.6594 78.7656C49.6416 78.7933 49.6286 78.8255 49.6212 78.8603C49.6138 78.8951 49.6122 78.9318 49.6165 78.9682C49.6207 79.0046 49.6307 79.04 49.6458 79.0722C49.661 79.1044 49.681 79.1328 49.7047 79.1557L56.7761 86.227C56.7991 86.2509 56.8256 86.269 56.8537 86.2801C56.8819 86.2913 56.9113 86.2953 56.9401 86.2919C56.969 86.2886 56.9966 86.2779 57.0215 86.2606C57.0464 86.2433 57.068 86.2197 57.0849 86.1911L63.1294 76.4196C63.2051 76.2974 63.2498 76.1484 63.2582 75.9906C63.2667 75.8327 63.2385 75.6727 63.177 75.5297L56.1365 59.417C56.0745 59.2742 56.0461 59.114 56.0545 58.956C56.0629 58.7981 56.108 58.649 56.1841 58.5271L59.4987 53.1687C59.5156 53.1403 59.5277 53.1077 59.5343 53.0728C59.5409 53.0378 59.5419 53.0012 59.5372 52.9651C59.5324 52.9289 59.5221 52.8939 59.5068 52.862C59.4915 52.8301 59.4715 52.802 59.448 52.7792Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2053 56.8752L60.4316 61.3593C60.3843 61.4407 60.357 61.5386 60.3529 61.6415C60.3489 61.7445 60.3682 61.8483 60.4086 61.9411L65.066 72.6467C65.0836 72.6875 65.1088 72.7227 65.1394 72.7491C65.17 72.7754 65.2049 72.7921 65.2411 72.7975C65.2772 72.803 65.3133 72.7971 65.3462 72.7803C65.3791 72.7635 65.4077 72.7365 65.4293 72.7016L70.6278 64.2977C70.645 64.2699 70.6574 64.2378 70.6643 64.2032C70.6712 64.1686 70.6725 64.1323 70.6681 64.0963C70.6636 64.0604 70.6536 64.0255 70.6385 63.9937C70.6234 63.9619 70.6035 63.9339 70.5801 63.9113L63.5118 56.8431C63.489 56.8195 63.463 56.8016 63.4351 56.7904C63.4073 56.7792 63.3783 56.775 63.3497 56.778C63.3212 56.781 63.2937 56.7911 63.2689 56.8078C63.2441 56.8245 63.2225 56.8474 63.2053 56.8752Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9529 75.059L48.7266 70.5749C48.7735 70.4932 48.8005 70.3954 48.8046 70.2926C48.8086 70.1898 48.7896 70.086 48.7496 69.9931L44.0853 59.2987C44.0669 59.2585 44.041 59.224 44.0101 59.1983C43.9792 59.1727 43.9442 59.1566 43.9081 59.1516C43.872 59.1465 43.8359 59.1526 43.803 59.1694C43.7702 59.1861 43.7415 59.213 43.7197 59.2476L38.5304 67.6365C38.5128 67.6639 38.5 67.6957 38.4925 67.7301C38.4851 67.7645 38.4833 67.8007 38.4873 67.8368C38.4912 67.8728 38.5008 67.9079 38.5154 67.9399C38.5301 67.972 38.5496 68.0004 38.5727 68.0235L45.644 75.0949C45.691 75.1418 45.7499 75.1644 45.8079 75.1577C45.8658 75.151 45.9179 75.1155 45.9529 75.059Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M59.448 52.7792L52.3766 45.7078C52.3305 45.6617 52.2726 45.6395 52.2157 45.6461C52.1588 45.6527 52.1075 45.6876 52.0732 45.7431L46.0149 55.5371C45.9392 55.6593 45.8944 55.8082 45.886 55.9661C45.8776 56.1239 45.9058 56.284 45.9673 56.4269L53.0077 72.5396C53.0698 72.6816 53.0986 72.841 53.0906 72.9983C53.0826 73.1556 53.038 73.3042 52.9624 73.4258L49.6594 78.7656C49.6416 78.7933 49.6286 78.8255 49.6212 78.8603C49.6138 78.8951 49.6122 78.9318 49.6165 78.9682C49.6207 79.0046 49.6307 79.04 49.6458 79.0722C49.661 79.1044 49.681 79.1328 49.7047 79.1557L56.7761 86.227C56.7991 86.2509 56.8256 86.269 56.8537 86.2801C56.8819 86.2913 56.9113 86.2953 56.9401 86.2919C56.969 86.2886 56.9966 86.2779 57.0215 86.2606C57.0464 86.2433 57.068 86.2197 57.0849 86.1911L63.1294 76.4196C63.2051 76.2974 63.2498 76.1484 63.2582 75.9906C63.2667 75.8327 63.2385 75.6727 63.177 75.5297L56.1365 59.417C56.0745 59.2742 56.0461 59.114 56.0545 58.956C56.0629 58.7981 56.108 58.649 56.1841 58.5271L59.4987 53.1687C59.5156 53.1403 59.5277 53.1077 59.5343 53.0728C59.5409 53.0378 59.5419 53.0012 59.5372 52.9651C59.5324 52.9289 59.5221 52.8939 59.5068 52.862C59.4915 52.8301 59.4715 52.802 59.448 52.7792Z",
    fill: "url(#paint13_linear_502_8487)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2053 56.8752L60.4316 61.3593C60.3843 61.4407 60.357 61.5386 60.3529 61.6415C60.3489 61.7445 60.3682 61.8483 60.4086 61.9411L65.066 72.6467C65.0836 72.6875 65.1088 72.7227 65.1394 72.7491C65.17 72.7754 65.2049 72.7921 65.2411 72.7975C65.2772 72.803 65.3133 72.7971 65.3462 72.7803C65.3791 72.7635 65.4077 72.7365 65.4293 72.7016L70.6278 64.2977C70.645 64.2699 70.6574 64.2378 70.6643 64.2032C70.6712 64.1686 70.6725 64.1323 70.6681 64.0963C70.6636 64.0604 70.6536 64.0255 70.6385 63.9937C70.6234 63.9619 70.6035 63.9339 70.5801 63.9113L63.5118 56.8431C63.489 56.8195 63.463 56.8016 63.4351 56.7904C63.4073 56.7792 63.3783 56.775 63.3497 56.778C63.3212 56.781 63.2937 56.7911 63.2689 56.8078C63.2441 56.8245 63.2225 56.8474 63.2053 56.8752Z",
    fill: "url(#paint14_linear_502_8487)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9529 75.059L48.7266 70.5749C48.7735 70.4932 48.8005 70.3954 48.8046 70.2926C48.8086 70.1898 48.7896 70.086 48.7496 69.9931L44.0853 59.2987C44.0669 59.2585 44.041 59.224 44.0101 59.1983C43.9792 59.1727 43.9442 59.1566 43.9081 59.1516C43.872 59.1465 43.8359 59.1526 43.803 59.1694C43.7702 59.1861 43.7415 59.213 43.7197 59.2476L38.5304 67.6365C38.5128 67.6639 38.5 67.6957 38.4925 67.7301C38.4851 67.7645 38.4833 67.8007 38.4873 67.8368C38.4912 67.8728 38.5008 67.9079 38.5154 67.9399C38.5301 67.972 38.5496 68.0004 38.5727 68.0235L45.644 75.0949C45.691 75.1418 45.7499 75.1644 45.8079 75.1577C45.8658 75.151 45.9179 75.1155 45.9529 75.059Z",
    fill: "url(#paint15_linear_502_8487)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_502_8487",
    x1: 30.7778,
    y1: 114.704,
    x2: 82.3943,
    y2: 12.5257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_502_8487",
    x1: 31.5705,
    y1: 115.103,
    x2: 83.187,
    y2: 12.9302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_502_8487",
    x1: 31.9649,
    y1: 115.3,
    x2: 83.5814,
    y2: 13.1271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_502_8487",
    x1: 32.7566,
    y1: 115.704,
    x2: 84.3731,
    y2: 13.5261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_502_8487",
    x1: 33.5443,
    y1: 116.103,
    x2: 85.1663,
    y2: 13.9252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_502_8487",
    x1: 34.337,
    y1: 116.502,
    x2: 85.9591,
    y2: 14.3299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_502_8487",
    x1: 35.1297,
    y1: 116.901,
    x2: 86.7463,
    y2: 14.7289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_502_8487",
    x1: 35.9219,
    y1: 117.3,
    x2: 87.5384,
    y2: 15.1279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_502_8487",
    x1: 36.7146,
    y1: 117.7,
    x2: 88.3311,
    y2: 15.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_502_8487",
    x1: 37.5022,
    y1: 118.099,
    x2: 89.1243,
    y2: 15.9261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_502_8487",
    x1: 38.295,
    y1: 118.503,
    x2: 89.917,
    y2: 16.3251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3A2484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C0232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_502_8487",
    x1: 21.4141,
    y1: 64.361,
    x2: 89.0207,
    y2: 64.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A2484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A2484",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_502_8487",
    x1: -18.2415,
    y1: 24.7165,
    x2: 110.297,
    y2: 94.0944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D189F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#9222FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF0CBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF536D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FF7BAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26BCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_502_8487",
    x1: 45.3045,
    y1: 56.6955,
    x2: 67.0163,
    y2: 70.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF536D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF536D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_502_8487",
    x1: 45.3045,
    y1: 56.6955,
    x2: 67.0163,
    y2: 70.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF536D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF536D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_502_8487",
    x1: 45.3045,
    y1: 56.6955,
    x2: 67.0163,
    y2: 70.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF536D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF536D",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin4);
export default __webpack_public_path__ + "static/media/coin4.245caa76.svg";
export { ForwardRef as ReactComponent };